// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-indication-bar {
  height: 26px;
  position: absolute;
  top: 0;
  left: 30%;
  display: flex;
  align-items: center;
}
.share-indication-bar .share-indication-tip {
  padding: 0 24px;
  max-width: 480px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #23d959;
  color: #202123;
  cursor: ew-resize;
  display: flex;
  align-items: center;
  height: 100%;
  border-bottom-left-radius: 6px;
}
.share-indication-bar .share-indication-tip .anticon {
  color: rgba(0, 0, 0, 0.6);
  margin-right: 3px;
}
.share-indication-bar .share-indication-tip .anticon path {
  fill: #000;
}
.share-indication-bar .share-indication-tip.share-indication-in-control {
  background: #ffbf39;
}
.share-indication-bar .share-bar-more {
  background: #000;
  height: 100%;
  width: auto;
  border: none;
  color: #fff;
  font-weight: 700;
}

.share-dropdown-menu {
  min-width: 254px;
  text-align: left;
  background: rgba(17, 17, 17, 0.8);
  max-height: 500px;
  overflow: auto;
}
.share-dropdown-menu .ant-dropdown-menu-item {
  padding: 5px 30px;
  color: #ccc;
  position: relative;
}
.share-dropdown-menu .ant-dropdown-menu-item .anticon-check {
  position: absolute;
  left: 10px;
  top: 10px;
}
.share-dropdown-menu .ant-dropdown-menu-item:hover {
  color: #40a9ff;
}
.share-dropdown-menu .ant-dropdown-menu-item-group-title {
  color: #fff;
  font-weight: 700;
}
.share-dropdown-menu .ant-dropdown-menu-item-active {
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/feature/video/components/share-indication.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AACF;AAAE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;AAEJ;AADI;EAIE,yBAAA;EACA,iBAAA;AAAN;AAJM;EACE,UAAA;AAMR;AADI;EACE,mBAAA;AAGN;AAAE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,gBAAA;EACE,gBAAA;EACA,iCAAA;EACA,iBAAA;EACA,cAAA;AACJ;AACE;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;AACJ;AAAI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAEN;AAAI;EACE,cAAA;AAEN;AACE;EACE,WAAA;EACA,gBAAA;AACJ;AACE;EACE,gBAAA;AACJ","sourcesContent":[".share-indication-bar {\n  height: 26px;\n  position: absolute;\n  top: 0;\n  left: 30%;\n  display: flex;\n  align-items: center;\n  .share-indication-tip {\n    padding: 0 24px;\n    max-width: 480px;\n    font-weight: 700;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    background: #23d959;\n    color: #202123;\n    cursor: ew-resize;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    border-bottom-left-radius: 6px;\n    .anticon {\n      path {\n        fill:#000;\n      }\n      color: rgba(0,0,0,0.6);\n      margin-right: 3px;\n    }\n    &.share-indication-in-control {\n      background: #ffbf39;\n    }\n  }\n  .share-bar-more {\n    background: #000;\n    height: 100%;\n    width: auto;\n    border: none;\n    color: #fff;\n    font-weight: 700;\n  }\n}\n\n.share-dropdown-menu{\n  min-width: 254px;\n    text-align: left;\n    background: rgba(17, 17, 17, 0.8);\n    max-height: 500px;\n    overflow: auto;\n \n  .ant-dropdown-menu-item {\n    padding: 5px 30px;\n    color: #ccc;\n    position: relative;\n    .anticon-check {\n      position: absolute;\n      left: 10px;\n      top: 10px;\n    }\n    &:hover {\n      color: #40a9ff;\n    }\n  }\n  .ant-dropdown-menu-item-group-title {\n    color: #fff;\n    font-weight: 700;\n  }\n  .ant-dropdown-menu-item-active{\n    background:none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
